module.exports = __webpack_public_path__ + "img/icon01.761136a.png";